import { FC } from 'react';
import { Global } from 'theme-ui';

export const GlobalStyles: FC = () => {
  return (
    <Global
      styles={{
        'html body': {
          color: 'primary',
        },
      }}
    />
  );
};
